import React from "react";
import { MdCall, MdMail, MdMap } from "react-icons/md";
import { GiWorld } from "react-icons/gi";
import { FaFacebook } from "react-icons/fa";
import { BsInstagram, BsMessenger } from "react-icons/bs";

const Footer = () => {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-[#d9cec2] pt-24 pb-20 gap-10 titlefont px-10">
      <div className="flex flex-col gap-7">
        <div>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F326391513_912063713158960_7875183330785571306_n.jpg?alt=media&token=ee074059-4b61-411f-b005-bbf1e5262f0b"
            className="w-20 rounded-full"
            alt=""
          />
        </div>
        <div className="text-[#7e6533] text-sm w-60 leading-6 tracking-wide">
          Myaniture is a versatile furniture and home-related products supplier
          sourcing the right products and best quality for its customers
        </div>
      </div>
      <div className="text-[#7e6533] flex flex-col gap-7">
        <h1 className=" text-[22px] tracking-wider font-medium"> Contact</h1>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <p className="">
              <MdMap />
            </p>
            <p className="text-sm">
              27B, Airport Avenue Road, 10 Mile, Yangon.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <p className="">
              <MdCall />
            </p>
            <p className="text-sm">09 44756 7277</p>
          </div>
          <div className="flex items-center gap-3">
            <p className="">
              <MdMail />
            </p>
            <p className="text-sm">myaniture@gmail.com</p>
          </div>
          <div className="flex items-center gap-3">
            <p className="">
              <GiWorld />
            </p>
            <p className="text-sm">myanitureshop.com</p>
          </div>
        </div>
      </div>
      <div className=" text-[#7e6533] text-sm lg:justify-self-end self-end flex gap-5 flex-col-reverse md:flex-col  ">
        <p className="lg:text-end">
          Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
          <span className="font-bold">MYANiture</span>
        </p>
        <div className="flex lg:justify-end  gap-5">
          <a href="https://www.facebook.com/MYANiture">
            {" "}
            <FaFacebook size={24} />
          </a>
          <a href="https://m.me/105816729037495">
            <BsMessenger size={24} />
          </a>
          <a href="https://instagram.com/myaniture?igshid=MzRlODBiNWFlZA==">
            {" "}
            <BsInstagram size={24} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
